import PhotoFormContainer from './PhotoFormContainer';

export default PhotoFormContainer;
